import { Alert, Button, message } from 'antd';
import { UserSwitchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import { ROUTES } from '../../constants/routes';
import { getDefaultPostLoginRoute } from '../../config/panelMenuAccess';
import { getApiErrorMessage } from '../../utils/apiError';

/**
 * بنر ثابت هنگام مشاهده پنل به‌عنوان کاربر دیگر (impersonation).
 */
const ImpersonationBanner = () => {
  const navigate = useNavigate();
  const {
    user,
    isImpersonating,
    stoppingImpersonation,
    stopImpersonation,
    impersonationLockedOrganizationId,
    activeOrganization,
  } = useAuth();

  if (!isImpersonating) return null;

  const handleStop = async () => {
    try {
      const restoredUser = await stopImpersonation();
      message.success('به حساب اصلی خود بازگشتید');
      navigate(getDefaultPostLoginRoute({ user: restoredUser }), { replace: true });
    } catch (e) {
      message.error(getApiErrorMessage(e, 'بازگشت به حساب اصلی ناموفق بود.'));
      navigate(ROUTES.LOGIN);
    }
  };

  return (
    <Alert
      type="warning"
      showIcon
      icon={<UserSwitchOutlined />}
      className="!rounded-none !border-x-0 !border-t-0"
      message={
        <span className="text-sm font-medium">
          شما در حال مشاهده پنل به‌عنوان{' '}
          <strong className="font-semibold">{user?.name || 'کاربر دیگر'}</strong> هستید.
          {impersonationLockedOrganizationId ? (
            <span className="mr-1 text-xs font-normal text-amber-800/90 dark:text-amber-200/90">
              {' '}
              (فقط سازمان «{activeOrganization?.name || 'فعلی'}»)
            </span>
          ) : null}
        </span>
      }
      action={
        <Button
          size="small"
          type="primary"
          danger
          loading={stoppingImpersonation}
          onClick={handleStop}
          className="!rounded-lg !text-xs !font-medium"
        >
          بازگشت به حساب خودم
        </Button>
      }
    />
  );
};

export default ImpersonationBanner;
